import { render, staticRenderFns } from "./MainHeaderPlatAPat.vue?vue&type=template&id=59722e96"
import script from "./MainHeaderPlatAPat.vue?vue&type=script&lang=js"
export * from "./MainHeaderPlatAPat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports